//
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'

/**
 * @description
 * This class describes a pch purchase order.
 *
 * @class      PchPurchaseOrder (name)
 */
export default class PchPurchaseOrderToList extends PurchaseOrderModel {

    /**
     * The default pch purchase order includes
     */
    static includes = [
        'pch_provider',
        'pch_purchase_order_state',
    ]
}
